export default "__VITE_PUBLIC_ASSET__a199b257__"